// extracted by mini-css-extract-plugin
module.exports = {"modal_det":"TargetMonth-module--modal_det--1rwlv"};